<template>
  <div style="height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 90%; height: 40px">
        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
          <el-input v-model="formDatas.auName" style="width: 120px;" size="mini" placeholder="名称" clearable></el-input>
          <el-input v-model="formDatas.auAccount" style="width: 120px;" size="mini" placeholder="账号"
            clearable></el-input>
          <el-select size="mini" v-model="formDatas.auPost" clearable @change="partserch" placeholder="请选择岗位"
            style="width: 130px">
            <el-option label="用户" :value="2" key="2"></el-option>
            <el-option label="管理员" :value="1" key="1"></el-option>
            <!-- <el-option label="处理失败" :value="3" key="3"></el-option> -->
          </el-select>
          <el-select size="mini" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
            v-if="post == 2" style="width: 130px">
            <el-option label="已删除" :value="2" key="2"></el-option>
            <el-option label="未删除" :value="1" key="1"></el-option>
          </el-select>
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="margin-left: 10px">搜索</el-button>
          <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
          <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
          <!-- <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button> -->
        </el-row>
      </div>
      <div style="width: 10%; height: 40px">
        <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
          <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增用户</el-button>

          <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            :checkbox-option="checkboxOption" row-key-field-name="auId" :cellSelectionOption="cellSelectionOption"
            style="width: 100%" :editOption="editOption" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
      <!-- 新增 -->
      <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑用户' : '新增用户'" :before-close="handleClose"
        :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
        <div class="demo-drawer__content" style="height: 90%;">
          <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
            <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
              <el-form-item label="用户名称" prop="auName">
                <el-input v-model="form.auName" style="width: 80%;" placeholder="请输入名称"></el-input>
              </el-form-item>
              <el-form-item label="账号" prop="auAccount">
                <el-input v-model="form.auAccount" style="width: 80%;" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="auPw">
                <el-input v-model="form.auPw" style="width: 80%;" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="auEmail">
                <el-input v-model="form.auEmail" style="width: 80%;" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="岗位" prop="auPost">
                <el-select v-model="form.auPost" clearable placeholder="请选择" style="width: 80%;">
                  <el-option label="用户" :value="2" key="2"></el-option>
                  <el-option label="管理员" :value="1" key="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="用户角色" label-width="100" prop="auRoleIds">
                <el-select v-model="form.auRoleIds" placeholder="请选择角色" clearable filterable multiple>
                  <el-option v-for="(item) in userAuth || []" :key="item.roleId" :label="item.roleName"
                    :value="item.roleId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商户地市" label-width="100" prop="ascId">
                <el-select v-model="form.ascId" placeholder="请选择角色" clearable filterable >
                  <el-option v-for="(item) in getAjefShopCityList_data || []" :key="item.ascId" :label="item.ascName"
                    :value="item.ascId"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="demo-drawer__footer" style="margin-top: 10px;">
          <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
          <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
            确 定</el-button>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefUserList, addAjefUser, updateAjefUser, deleteAjefUser, getAjefRoleList,getAjefShopCityList } from "../../api/api";
export default {
  name: "",
  components: {},
  data() {
    return {
      getAjefShopCityList_data: [],
      userAuth: [],
      theRow: {},
      form2: {},
      diaAddReturn: false,
      diaDetail: false,
      tableDataDetail: [],
      statusAll: [
        { id: 1, name: "闲置" },
        { id: 2, name: "领用" },
        { id: 3, name: "损坏" },
        { id: 4, name: "丢失" },
      ],
      dialogStatusValue: '',
      dialogStatus: false,
      key: 'auId',
      dialog: false,
      edit: false,
      form: {
      },
      rules: {},
      // 未编辑前的值
      lastValue: "",
      // 单元格编辑功能
      editOption: {
        beforeCellValueChange: ({ row, column, changeValue }) => {
          this.beforeCellValChange(row, column, changeValue);
        },
        afterCellValueChange: ({ row, column, changeValue }) => {
          this.afterCellValChange(row, column, changeValue);
        },
      },
      cellSelectionOption: {
        // disble cell selection
        enable: true,
      },
      totalCount: 100,
      pageIndex: 1,
      pageSize: 10,
      selectedRowKeysCollection: [],
      checkboxOption: {
        // 可控属性
        selectedRowKeys: [],
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.changeSelectedRowKeys(row, isSelected, this.key);
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.changeSelectAll(isSelected, selectedRowKeys, this.key);
        },
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      windheight: "",
      tableHight: 520,

      columns: [
        {
          field: "",
          key: "checkbox",
          // type=checkbox
          type: "checkbox",

          title: "",
          width: 50,
          align: "center",
        },
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "auName",
          key: "auName",
          title: "用户名称",
          align: "center",
        },
        {
          field: "auAccount",
          key: "auAccount",
          title: "账号",
          align: "center",
        },
        {
          field: "auEmail",
          key: "auEmail",
          title: "邮箱",
          align: "center",
        },
        {
          field: "auPost",
          key: "auPost",
          title: "岗位",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {
                  row.auPost == 1 ? <el-tag size="mini">管理员</el-tag> : <el-tag type="danger" size="mini">用户</el-tag>
                }
              </span>
            );
          },
        },
        {
          field: "auRoleNames",
          key: "auRoleNames",
          title: "角色",
          align: "center",
        },
   {
          field: "ascName",
          key: "ascName",
          title: "地市",
          align: "center",
        },
        { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
        {
          field: "",
          key: "d",
          title: "操作",
          width: 200,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <el-button
                  size="mini"
                  type="text"
                  on-click={() => this.handleEdit(row)}
                >
                  编辑
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  style="color: red"
                  on-click={() => this.handleDelete(row)}
                >
                  删除
                </el-button>
              </span>
            );
          },
        },
      ], //表格的列
      tableData: [],
      post: null,
      formDatas: {
        dmDelete: '',
        currentPage: 1,
        pageSize: 10,
      },
      bulkImport: false,
      bulkData: [],
      bulkDataCopy: [],
      sitId: '',
      importData: {},

    };
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  created() {
    this.windheight = this.$store.state.windheight
    this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    this.getList();
    getAjefRoleList({pageSize: 0}).then(res => {
      this.userAuth = res.data
    })
     getAjefShopCityList({pageSize: 0}).then(res => {
      this.getAjefShopCityList_data = res.data
    })
  },
  mounted() { },
  methods: {
    openLoading() {
      //loading请求等待
      this.loadings = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    bulkImportClick() {
      if (this.sitId == '') {
        this.$message({
          showClose: true,
          message: "请导入资料",
          type: 'danger'
        });
      } else {
        uploadImportAjAssetsKey({
          sitId: this.sitId
        }).then(res => {
          this.getList()
          this.bulkImport = false;
          this.bulkData = [];
          this.bulkDataCopy = [];
          this.sitId = '';
          this.$refs['bulk'].clearFiles()
          this.$message({
            type: 'success',
            message: '导入成功!'
          });
        })
      }

    },
    async updatabulk(file, fileList) {
      console.log(file, fileList);
      let Data = new FormData();
      Data.append('file', file.raw)
      this.openLoading()
      uploadAjAssetsFireEquipment(Data).then(res => {
        console.log("上传成功")
        this.loadings.close()
        this.bulkData = res.data.data.resultList;
        this.bulkDataCopy = res.data.data.resultList;
        this.importData = res.data.data.importData;
        this.sitId = res.data.data.sysImportTem.sitId;

      })
    },
    bulkImportClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
          this.bulkData = [];
          this.bulkDataCopy = [];
          this.$nextTick(() => {
            this.getList()
          })
          this.$refs.bulk.clearFiles();
        })
        .catch(_ => { });
    },
    handleStatus(row) {
      this.theRow = row;
      this.dialogStatusValue = row.aakStatus;
      this.dialogStatus = true;
    },
    sureStatus() {
      updateAjAssetsFireEquipmentStatus({ auId: this.theRow.auId, aakStatus: this.dialogStatusValue }).then(res => {
        if (res.data) {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.getList();
          this.dialogStatusValue = ''
        }
      })
      this.dialogStatus = false;
    },
    closeStatus() {
      this.dialogStatus = false;
      this.dialogStatusValue = ''
    },
    // 批量删除
    BulkDelete() {
      if (this.selectedRowKeysCollection.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择",
          type: 'danger'
        });
      } else if (this.selectedRowKeysCollection.length > 0) {
        this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            deleteAjefUser({ auIds: this.selectedRowKeysCollection.toString() }).then(res => {
              if (res.data) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });

                this.partserch()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
      }
    },
    handleDelete(row) {
      this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {

          deleteAjefUser({ auId: row.auId }).then(res => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });

              this.partserch()
            }
          })
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        })
    },
    handleEdit(row) {
      const data = JSON.parse(JSON.stringify(row))
      this.dialog = true;
      this.edit = true;
      this.$nextTick(() => {
        this.form = data;
        this.form.auRoleIds = row.auRoleIds.split(",").map(Number);
      })
    },
    SureBtn() {
      if (!this.edit) {
        this.$confirm("是否确定要新增, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.form.auRoleIds = this.form.auRoleIds.toString()
            addAjefUser(this.form).then(res => {
              if (res.data) {
                this.$message({
                  type: "success",
                  message: "新增成功!",
                });
                this.handleClose()
                this.getList()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
      } else {
        this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.form.auRoleIds = this.form.auRoleIds.toString()
            updateAjefUser(this.form).then(res => {
              if (res.data) {
                this.$message({
                  type: "success",
                  message: "编辑成功!",
                });
                this.handleClose()
                this.getList()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
      }

    },
    BoxOpen() {
      this.dialog = true;

    },
    // 关闭弹框
    handleClose() {
      this.dialog = false;
      this.edit = false;
      this.$refs['formRef'].resetFields();
    },

    // 修改单元格
    async beforeCellValChange(row, column, changeValue) {
      if (row[column.field] == changeValue) {
        return false;
      }

      this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var jsonObj = {};
          let formData = new FormData();
          formData.append(column.field, changeValue);
          formData.forEach((value, key) => (jsonObj[key] = value));
          jsonObj.auId = row.auId
          console.log(jsonObj);
          updateAjefUser(jsonObj).then(res => {
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
          })

        })
        .catch(() => {
          this.lastValue = row[column.field];
          this.$nextTick(() => {
            this.tableData.forEach((item) => {
              for (let key in item) {
                if (key == column.field && item[key] == changeValue) {
                  item[key] = this.lastValue;
                }
                console.log(key);
              }
            });
          });
          this.$message({
            type: "info",
            message: "已取消编辑",
          });
          return false;
        });
    },
    afterCellValChange(row, column, changeValue) {
      // console.log(" afterCellValChange", row, column, changeValue);
    },
    // reset selectedRowKeys
    resetSelectedRowKeys(key) {

      this.checkboxOption.selectedRowKeys = [];

      const selectedRowKeysCollection = this.selectedRowKeysCollection;

      if (selectedRowKeysCollection.length) {
        this.tableData.forEach((item) => {
          if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
            console.log(item);
            this.checkboxOption.selectedRowKeys.push(item[key]);
          }
        });
      }
    },
    // select all change
    changeSelectAll(isSelected, selectedRowKeys, key) {

      this.checkboxOption.selectedRowKeys = selectedRowKeys;

      if (isSelected) {
        this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
      } else {
        this.tableData.forEach((item, index) => {
          if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
            this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
          }
        });
      }
    },
    changeSelectedRowKeys(row, isSelected, key) {

      const rowKey = row[key];

      if (isSelected) {
        this.checkboxOption.selectedRowKeys.push(rowKey);
        this.selectedRowKeysCollection.push(rowKey);
        console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
      } else {
        const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
        this.checkboxOption.selectedRowKeys.splice(index, 1);
        this.selectedRowKeysCollection.splice(index, 1);
      }
    },
    pageSizeChange(pageSize) {

      this.formDatas.pageSize = pageSize;
      this.partserch();


    },
    pageNumberChange(pageIndex) {
      console.log(pageIndex);
      this.formDatas.currentPage = pageIndex;
      getAjefUserList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys(this.key);
        // this.$message({
        //   type: "success",
        //   message: "搜索成功!",
        // });
      });

    },
    partserch() {
      this.formDatas.currentPage = 1;
      getAjefUserList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys(this.key);
        // this.$message({
        //   type: "success",
        //   message: "搜索成功!",
        // });
      });
    },
    getList() {
      getAjefUserList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
      });
    },
  },
};
</script>

<style>
.table-header-cell-class {
  background: var(--bg-color) !important;
  color: var(--font-color) !important;
  border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
  display: none;
}

.ve-table-container {
  height: auto !important;
}
</style>